import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import { fa } from "app/main/std";
import { formatMinutes } from "app/features/selectores";
import { CanalEntradaText } from "app/features/selectores";
import { QuienSolicitaText } from "app/features/selectores";
import { tooltip } from "leaflet";

type Entity = models.BitacoraRADDto;
type Column = kea.Grid2Column<Entity>;

const columnasFijas: Column[] = [
    { title: "Status", cell: x => ({ data: models.StatusBitacoraRad[x.Status!] }) },
    { title: "Fecha sol.", cell: x => ({ data: kea.toDate(x.FechaSolicitud) }) },
    { title: "Fecha prog.", cell: x => ({ data: kea.toDate(x.FechaProgramada) }) },
    { title: "Tipo de sol", cell: x => ({ data: models.HorarioRad[x.TipoRecoleccion!] }) },
    { title: "Sucursal que solicita", cell: x => ({ data: x.NombreSucursal }) },
    { title: "cant paquetes", cell: x => ({ data: x.CantPaquetes }) },
    { title: "Paquetes (detalle)", cell: x => ({ data: (x.DescripcionPaquetesTexto || "").split(",") }) },
    { title: "Sucursal de recolección", cell: x => ({ data: x.NombreSucursalRecoleccion}) },
    { title: "Cliente", cell: x => ({ data: x.NombreCliente }) },
    { title: "Direccion", cell: x => ({ data: x.DireccionDto.Descripcion }) },
    { title: "Teléfono", cell: x => ({ data: x.Telefono }) },
    { title: "Horario sugerido", cell: x => ({ data: formatMinutes(x.HorarioSugeridoDesde!) + " - " + formatMinutes(x.HorarioSugeridoHasta!) }) },
    { title: "Usuario que elaboró", cell: x => ({ data: x.UsuarioCreador })},
    { title: "Quien solicita", cell: x => ({ data: QuienSolicitaText (x.QuienSolicita) })},
    { title: "Nombre de quien solicita", cell: x => ({ data: x.NombreQuienSolicita })},
    { title: "Canal de Entrada", cell: x => ({ data: CanalEntradaText(x.CanalEntrada) })},
    { title: "Observaciones", cell: x => ({ data: x.Observaciones }) },
    { title: "Folio de recolección / Observaciones", cell: x => ({ data: ( x.HistorialStatus != null ? x.HistorialStatus[0].Observaciones : ""  ) })},
];

export interface BotonesListaDeps {
    onAceptar: (x: Entity) => void;
    onCancelar: (x: Entity) => void;
    onStatus: (x: Entity) => void;
    onVer: (x: Entity) => void;
    onVerModal: (x: Entity) => void;
}

export function columnas(deps: BotonesListaDeps): Column[] {
    const botones = kea.columnaBotones([
        { onClick: deps.onAceptar, tooltip: "Finalizar", iconClass: fa("check") },
        { onClick: deps.onCancelar, tooltip: "Cancelar", iconClass: fa("times") },
        { onClick: deps.onStatus, tooltip: "Ver status", iconClass: fa("list-ul") },
        { onClick: deps.onVer, tooltip: "Ver", iconClass: fa("eye") },
        { onClick: deps.onVerModal, tooltip: "Ver Modal", iconClass: fa("book") },
    ]);

    return [botones, ...columnasFijas];
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/bitacoraRAD/list/columns.tsx